import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Storage from "@/core/config/Storage";

const routes: Array<any> = [
  {
    path: "/",
    name: "home-page",
    redirect: "/sellstock",
    component: () => import("@/views/Home.vue"),
    children: [],
  },
  {
    path: "/transfer",
    name: "transfer-page",
    component: () => import("@/views/Transfer.vue"),
  },
  {
    path: "/pg-orders",
    name: "pg-orders",
    component: () => import("@/views/PGOrders.vue"),
  },
  {
    path: "/:ref",
    name: "ref-page",
    component: () => import("@/views/Home.vue"),
  },
  {
    name: "Login",
    path: "/sellstock/login",
    component: () => import("@/views/sellstock/authentication/LoginPage1.vue"),
  },
  {
    name: "CryptoTransactionDetail",
    path: "/payportal",
    component: () => import("@/views/sellstock/transaction/Crypto.vue"),
  },
  {
    path: "/main",
    redirect: "/sellstock",
    component: () => import("@/views/sellstock/layouts/DashboardLayout.vue"),
    children: [
      {
        name: "Lists",
        path: "/sellstock",
        component: () => import("@/views/sellstock/downline/Lists.vue"),
      },
      {
        name: "DownlineUser",
        path: "/sellstock/:user+",
        component: () => import("@/views/sellstock/downline/Lists.vue"),
      },
      {
        name: "Account",
        path: "/sellstock/account",
        component: () => import("@/views/sellstock/bank/Lists.vue"),
      },
      {
        name: "Transactions",
        path: "/sellstock/transaction",
        component: () => import("@/views/sellstock/transaction/Lists.vue"),
      },
      {
        name: "LoginHistory",
        path: "/sellstock/downline/login-history/:username",
        component: () => import("@/views/sellstock/downline/LoginHistory.vue"),
      },
      {
        name: "BankListsUser",
        path: "/sellstock/downline/bank-list/:username",
        component: () => import("@/views/sellstock/downline/BankListUser.vue"),
      },
      {
        name: "Reports",
        path: "/sellstock/reports",
        component: () =>
          import("@/views/sellstock/transaction/reports/Lists.vue"),
      },
      {
        name: "ReportsDetail",
        path: "/sellstock/reports/:user+",
        component: () =>
          import("@/views/sellstock/transaction/reports/Lists.vue"),
      },
      {
        name: "ProviderReport",
        path: "/sellstock/provider-report",
        component: () =>
          import("@/views/sellstock/transaction/reports/ProviderReport.vue"),
        beforeEnter: (to: any, from: any, next: any) => {
          const username = localStorage.getItem("username")?.toLowerCase();
          if (
            to.name === "ProviderReport" &&
            username != process.env.VUE_APP_USERNAME_MAIN?.toLowerCase()
          ) {
            next("/sellstock");
          } else {
            next();
          }
        },
      },
      {
        name: "HowToUse",
        path: "/sellstock/how-to-use",
        component: () => import("@/views/sellstock/HowtoUse.vue"),
      },
      {
        name: "Remaining",
        path: "/sellstock/remaining",
        component: () =>
          import("@/views/sellstock/transaction/reports/Remaining.vue"),
        beforeEnter: (to: any, from: any, next: any) => {
          const username = localStorage.getItem("username")?.toLowerCase();
          if (
            to.name === "Remaining" &&
            username != process.env.VUE_APP_USERNAME_MAIN?.toLowerCase()
          ) {
            next("/sellstock");
          } else {
            next();
          }
        },
      },
      {
        name: "AllTransactions",
        path: "/sellstock/transaction/all",
        component: () =>
          import("@/views/sellstock/transaction/AllTransactions.vue"),
        beforeEnter: (to: any, from: any, next: any) => {
          const username = localStorage.getItem("username")?.toLowerCase();
          if (
            to.name === "AllTransactions" &&
            username != process.env.VUE_APP_USERNAME_MAIN?.toLowerCase()
          ) {
            next("/sellstock");
          } else {
            next();
          }
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to: any, from: any, next: any) => {
  const isAuthenticated = await Storage.checkToken();
  const publicRoutes = ["home-page", "transfer-page", "pg-orders", "ref-page"];
  if (publicRoutes.includes(to.name)) {
    next();
  }
  if (!["Login"].includes(to.name) && !isAuthenticated) {
    await Storage.clearToken();
    next({ name: "Login" });
  } else if (["Login"].includes(to.name) && isAuthenticated) {
    next({ name: "Lists" });
  } else {
    next();
  }
});

export default router;
